export default {
    hAvatar: {
        borderRadius: "50%",
        width: "33px",
        marginTop: "auto",
        marginBottom: "auto",
        marginLeft: "24px"
    },
    invitedAvatar: {
        width: "33px",
        height: "33px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        marginTop: "auto",
        textAlign: "center",
        marginBottom: "auto",
        fontSize: "15px",
        color: "white",
        marginLeft: "24px"
    },
    hMessageBarCont: {
        display: "flex",
        height: "32px",
        color: "white",
        justifyContent: "space-between",
        paddingLeft: "48px",
        paddingRight: "48px"
    },
    hMessageBarWarn: {
        backgroundColor: "#f28686"
    },
    hMessageBarSpan: {
        marginTop: "auto",
        marginBottom: "auto"
    },
    hMessageBarAction: {
        cursor: "pointer",
        textDecoration: "underline"
    }
};